export default "__VITE_ASSET__711e502a__"